/* Aimer Joias — Landing de Revenda (Atacado) v3 · JS sem dependências.
   Cada recurso roda isolado (try/catch): se um falhar, o resto da página continua. */
(function () {
  'use strict';
  var root = document.querySelector('.arv');
  if (!root || root.__arv) return;
  root.__arv = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var saveData = !!conn.saveData;
  var hasIO = 'IntersectionObserver' in window;
  var data = {};
  try { data = JSON.parse(document.getElementById('arv-data').textContent); } catch (e) {}

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function safe(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[aimer-revenda] ' + name, e); } }
  function onView(el, cb, opts) {
    if (!hasIO) { cb(true); return null; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, opts || {});
    io.observe(el);
    return io;
  }

  /* ---------- Entradas ao rolar ---------- */
  safe('reveal', function () {
    var els = $$('[data-arv-reveal]');
    if (!hasIO || reduce) return;
    els.forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.hasAttribute('data-arv-reveal'); });
      el.style.setProperty('--rd', Math.min(sibs.indexOf(el), 6) * 90 + 'ms');
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
    root.classList.add('arv-js');
  });

  /* ---------- Contadores ---------- */
  safe('contadores', function () {
    if (reduce || !hasIO) return;
    $$('[data-arv-count]').forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-arv-count'));
      var from = parseFloat(el.getAttribute('data-arv-from') || '0');
      el.textContent = String(from);
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var t0 = performance.now(), dur = 1600;
        (function step(now) {
          var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = String(Math.round(from + (to - from) * e));
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  });

  /* ---------- Rolagem suave para as âncoras ---------- */
  safe('ancoras', function () {
    $$('[data-arv-goto]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  });

  /* ---------- Vídeo do hero ---------- */
  var heroVideo = $('[data-arv-hero-video]');
  safe('hero-video', function () {
    if (!heroVideo || reduce || saveData) return;
    var visible = true;
    heroVideo.addEventListener('playing', function () { heroVideo.classList.add('is-playing'); });
    function start() {
      if (!heroVideo.getAttribute('src')) heroVideo.setAttribute('src', heroVideo.getAttribute('data-src'));
      if (visible) { var p = heroVideo.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (document.readyState === 'complete') setTimeout(start, 250);
    else window.addEventListener('load', function () { setTimeout(start, 250); });
    onView(heroVideo, function (inView) {
      visible = inView;
      if (!heroVideo.getAttribute('src')) return;
      if (inView) { var p = heroVideo.play(); if (p && p.catch) p.catch(function () {}); } else heroVideo.pause();
    });
  });

  /* ---------- Filme (com som) ---------- */
  safe('filme', function () {
    var dlg = $('[data-arv-film]'), open = $('[data-arv-film-open]');
    if (!dlg || !open) return;
    var v = $('video', dlg);
    function close() {
      v.pause();
      if (dlg.close && dlg.open) dlg.close(); else dlg.removeAttribute('open');
    }
    open.addEventListener('click', function () {
      // pôster só ao abrir: com o diálogo fechado o <video poster> baixava a imagem logo no início (20/out/2026)
      if (!v.getAttribute('poster') && v.getAttribute('data-poster')) v.setAttribute('poster', v.getAttribute('data-poster'));
      if (!v.getAttribute('src')) {
        var hls = v.canPlayType('application/vnd.apple.mpegurl') ? v.getAttribute('data-src-hls') : '';
        v.setAttribute('src', hls || v.getAttribute('data-src-mp4'));
      }
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      if (heroVideo) heroVideo.pause();
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    $('[data-arv-film-close]', dlg).addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && (dlg.open || dlg.hasAttribute('open'))) { e.preventDefault(); close(); }
    });
    dlg.addEventListener('close', function () {
      v.pause();
      if (heroVideo && heroVideo.getAttribute('src') && !reduce) { var p = heroVideo.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });

  /* ---------- Estúdio 360° ---------- */
  safe('estudio-360', function () {
    var spin = $('[data-arv-spin]');
    var pieces = data.pieces || [];
    if (!spin || !pieces.length) return;
    var surface = $('[data-arv-spin-surface]', spin);
    var layerA = $('[data-layer="a"]', spin), layerB = $('[data-layer="b"]', spin);
    var poster = $('.arv-spin__poster', spin);
    var degEl = $('[data-arv-deg]', spin);
    var needle = $('.arv-spin__needle', spin);
    var toggle = $('[data-arv-spin-toggle]', spin);
    var boxStones = $('[data-arv-stones]'), boxPieces = $('[data-arv-pieces]');
    var elFamily = $('[data-arv-family]'), elName = $('[data-arv-name]'), elStone = $('[data-arv-stone]');
    var N = 36, COLS = 6, STEP = 360 / N, AUTO = 28; // graus por segundo
    var angle = 0, vel = 0, dragging = false, lastX = 0, lastT = 0, lastFrame = -1;
    var auto = !reduce, resumeAt = 0, inView = false, ready = false, loaded = false, raf = 0, tLast = 0, token = 0;
    var cur = { p: 0, v: 0 };
    // sprite leve (6x6, 540 px) primeiro; depois 4 folhas HD (3x3, até 960 px) no tamanho certo para a tela
    var lowUrl = '', hdUrls = null;

    function pos(el, k) {
      var url, size, x, y;
      if (hdUrls) { var s = Math.floor(k / 9), q = k % 9; url = hdUrls[s]; size = '300% 300%'; x = (q % 3) * 50; y = Math.floor(q / 3) * 50; }
      else { url = lowUrl; size = '600% 600%'; x = (k % COLS) * 20; y = Math.floor(k / COLS) * 20; }
      if (el._u !== url) { el.style.backgroundImage = 'url("' + url + '")'; el._u = url; }
      if (el._s !== size) { el.style.backgroundSize = size; el._s = size; }
      el.style.backgroundPosition = x + '% ' + y + '%';
    }
    function moving() { return dragging || Math.abs(vel) > 4 || (auto && performance.now() > resumeAt); }
    function render() {
      var a = ((angle % 360) + 360) % 360;
      // os vídeos giram com a frente da peça indo para a esquerda; ângulo crescente = frente para a direita
      // (acompanha o dedo ao arrastar para a direita), então os quadros andam ao contrário
      var fa = (360 - a) % 360;
      var f = fa / STEP, k0, k1, blend = 0;
      if (moving()) {
        // em movimento: segura o quadro e só funde com o próximo no fim do intervalo (sem "fantasma" longo)
        k0 = Math.floor(f) % N; k1 = (k0 + 1) % N;
        blend = Math.max(0, (f - Math.floor(f) - 0.6) / 0.4);
      } else {
        // parado: um único quadro, nítido
        k0 = Math.round(f) % N; k1 = (k0 + 1) % N;
      }
      if (k0 !== lastFrame) { pos(layerA, k0); pos(layerB, k1); lastFrame = k0; }
      layerB.style.opacity = ready ? blend.toFixed(3) : 0;
      var d = Math.round(a) % 360;
      degEl.textContent = d;
      surface.setAttribute('aria-valuenow', d);
      surface.setAttribute('aria-valuetext', d + ' graus');
      if (needle) needle.setAttribute('transform', 'rotate(' + a.toFixed(2) + ' 300 300)');
    }
    function tick(now) {
      raf = 0;
      var dt = tLast ? Math.min(0.05, (now - tLast) / 1000) : 0;
      tLast = now;
      if (!dragging) {
        if (Math.abs(vel) > 4) { angle += vel * dt; vel *= Math.pow(0.035, dt); }
        else { vel = 0; if (auto && now > resumeAt) angle += AUTO * dt; }
      }
      render();
      if (inView && (dragging || Math.abs(vel) > 4 || auto)) raf = requestAnimationFrame(tick);
      else { tLast = 0; lastFrame = -1; render(); }
    }
    function kick() { if (!raf && inView) { tLast = 0; raf = requestAnimationFrame(tick); } }

    function loadHD(v, my) {
      if (!v.hd || !v.hd.length) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      var need = spin.getBoundingClientRect().width * 0.82 * dpr; // pixels físicos da área da peça
      if (need <= 600) return; // o sprite leve de 540 px já basta
      var px = need <= 720 ? 720 : need <= 840 ? 840 : 960;
      var urls = v.hd.map(function (u) {
        if (px >= v.hdPx) return u;
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px * 3; // o CDN da Shopify reduz a folha
      });
      var faltam = urls.length, falhou = false;
      urls.forEach(function (u) {
        var im = new Image();
        function ok() {
          if (my !== token || falhou) return;
          if (--faltam === 0) { hdUrls = urls; lastFrame = -1; render(); }
        }
        im.onload = function () { if (im.decode) im.decode().then(ok, ok); else ok(); };
        im.onerror = function () { falhou = true; };
        im.src = u;
      });
    }

    function load() {
      var v = pieces[cur.p].variants[cur.v];
      var my = ++token;
      ready = false; hdUrls = null;
      spin.classList.remove('is-ready');
      spin.classList.add('is-loading');
      poster.src = v.poster;
      var img = new Image();
      img.onload = function () {
        if (my !== token) return;
        function set() {
          if (my !== token) return;
          lowUrl = v.sprite;
          lastFrame = -1; ready = true;
          spin.classList.add('is-ready');
          spin.classList.remove('is-loading');
          render(); kick();
          loadHD(v, my);
        }
        if (img.decode) img.decode().then(set, set); else set();
      };
      img.onerror = function () { if (my === token) spin.classList.remove('is-loading'); };
      img.src = v.sprite;
    }

    function paintInfo() {
      var p = pieces[cur.p], v = p.variants[cur.v];
      elFamily.textContent = 'Família ' + p.family;
      elName.textContent = p.name;
      elStone.textContent = v.stone;
      $$('button', boxPieces).forEach(function (b, i) { b.setAttribute('aria-pressed', i === cur.p ? 'true' : 'false'); });
      boxStones.innerHTML = '';
      p.variants.forEach(function (vv, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'arv-stone-btn';
        b.setAttribute('aria-pressed', i === cur.v ? 'true' : 'false');
        b.innerHTML = '<i style="--c:' + vv.color + '"></i>' + vv.stone;
        b.addEventListener('click', function () {
          if (cur.v === i) return;
          cur.v = i; paintInfo(); if (loaded) load();
        });
        boxStones.appendChild(b);
      });
      surface.setAttribute('aria-label', 'Girar ' + p.name + ' com ' + v.stone + ' em 360 graus. Use as setas do teclado.');
    }

    pieces.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'arv-piece-btn';
      b.innerHTML = '<img src="' + p.variants[0].poster + '" alt="" width="540" height="540" loading="lazy" decoding="async"><span>' + p.name + '</span>';
      b.addEventListener('click', function () {
        if (cur.p === i) return;
        cur.p = i; cur.v = 0; paintInfo(); if (loaded) load();
        if (window.innerWidth < 1100) spin.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
      boxPieces.appendChild(b);
    });
    paintInfo();

    onView(spin, function (vis) {
      inView = vis;
      if (vis && !loaded) { loaded = true; load(); }
      if (vis) kick();
    }, { rootMargin: '300px 0px' });

    function touched() { spin.classList.add('was-touched'); }
    surface.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; vel = 0; lastX = e.clientX; lastT = performance.now();
      spin.classList.add('is-dragging'); touched();
      if (surface.setPointerCapture) { try { surface.setPointerCapture(e.pointerId); } catch (err) {} }
      kick();
    });
    surface.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var now = performance.now(), dx = e.clientX - lastX;
      var degPx = 360 / Math.max(240, surface.clientWidth * 1.15);
      var dA = dx * degPx;
      angle += dA;
      var dts = Math.max(8, now - lastT) / 1000;
      vel = vel * 0.35 + (dA / dts) * 0.65;
      lastX = e.clientX; lastT = now;
      render();
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      spin.classList.remove('is-dragging');
      if (performance.now() - lastT > 90) vel = 0;
      vel = Math.max(-900, Math.min(900, vel));
      resumeAt = performance.now() + 3500;
      kick();
    }
    surface.addEventListener('pointerup', end);
    surface.addEventListener('pointercancel', end);
    surface.addEventListener('lostpointercapture', end);
    surface.addEventListener('keydown', function (e) {
      var k = e.key, d = 0;
      if (k === 'ArrowRight' || k === 'ArrowUp') d = STEP;
      else if (k === 'ArrowLeft' || k === 'ArrowDown') d = -STEP;
      else if (k === 'PageUp') d = 45; else if (k === 'PageDown') d = -45;
      else if (k === 'Home') { angle = 0; d = 0.0001; }
      if (!d) return;
      e.preventDefault(); touched();
      angle += d; vel = 0; resumeAt = performance.now() + 5000; render();
    });
    function setAuto(on) {
      auto = on;
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.setAttribute('aria-label', on ? 'Pausar o giro automático' : 'Retomar o giro automático');
      if (on) { resumeAt = 0; kick(); }
    }
    setAuto(auto);
    toggle.addEventListener('click', function () { setAuto(!auto); });
    render();
  });

  /* ---------- Acabamento (ouro × ródio) ---------- */
  safe('acabamento', function () {
    var fig = $('[data-arv-finish-view]');
    var svg = fig && $('svg', fig);
    if (svg && window.matchMedia) {
      // no celular as legendas saem do SVG (viram lista HTML) e o desenho é recortado para ficar maior
      var mq = window.matchMedia('(max-width: 699px)'), vb = svg.getAttribute('viewBox');
      var fit = function () { svg.setAttribute('viewBox', mq.matches ? '0 34 470 396' : vb); };
      fit();
      if (mq.addEventListener) mq.addEventListener('change', fit);
    }
    var btns = $$('[data-arv-finish]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-arv-finish');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (fig) fig.setAttribute('data-arv-finish-view', v);
      });
    });
  });

  /* ---------- "O que muda": foto acompanha o item em foco ---------- */
  safe('resultados', function () {
    var sec = $('.arv-gains');
    if (!sec || !hasIO) return;
    var imgs = $$('[data-arv-gain-img]', sec), dots = $$('.arv-gains__dots i', sec), items = $$('[data-arv-gain]', sec);
    var mq = window.matchMedia('(min-width: 900px)');
    function setActive(i) {
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
    }
    function sync() { sec.classList.toggle('is-scrolly', mq.matches && !reduce); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    setActive(0);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) setActive(parseInt(e.target.getAttribute('data-arv-gain'), 10)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(function (it) { io.observe(it); });
  });

  /* ---------- Reels: só tocam quando visíveis ---------- */
  safe('reels', function () {
    $$('[data-arv-reel]').forEach(function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      function play() {
        if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      if (reduce || saveData) {
        v.parentNode.addEventListener('click', function () { if (v.paused) play(); else v.pause(); });
        return;
      }
      onView(v, function (vis) { if (vis) play(); else if (v.getAttribute('src')) v.pause(); }, { threshold: 0.45 });
    });
  });

  /* ---------- Linha do passo a passo + parallax ---------- */
  safe('rolagem', function () {
    var steps = $('[data-arv-steps]'), stepEls = steps ? $$('.arv-step', steps) : [];
    var par = reduce ? null : $('[data-arv-parallax]');
    var parImg = par ? $('img', par) : null;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      if (steps) {
        var r = steps.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (vh * 0.55)));
        steps.style.setProperty('--p', p.toFixed(3));
        stepEls.forEach(function (s, i) { s.classList.toggle('is-lit', p >= (i / Math.max(1, stepEls.length - 1)) - 0.02); });
      }
      if (parImg) {
        var rp = par.getBoundingClientRect();
        if (rp.bottom > 0 && rp.top < vh) {
          var c = (rp.top + rp.height / 2 - vh / 2) / vh;
          parImg.style.transform = 'translate3d(0,' + (c * -7).toFixed(2) + '%,0)';
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  /* ---------- CTA fixo ---------- */
  safe('cta-fixo', function () {
    var bar = $('[data-arv-sticky]');
    if (!bar || !hasIO) return;
    var link = $('a', bar);
    var state = { hero: true, form: false, close: false };
    function paint() {
      var on = !state.hero && !state.form && !state.close;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      link.setAttribute('tabindex', on ? '0' : '-1');
    }
    [['hero', '.arv-hero'], ['form', '#cadastro'], ['close', '.arv-close']].forEach(function (pair) {
      var el = $(pair[1]);
      if (!el) return;
      onView(el, function (vis) { state[pair[0]] = vis; paint(); });
    });
  });
})();
